<div class="qb-disconnected">
  <div class="qb-disconnected__bg-shape qb-disconnected__bg-shape--top"></div>
  <div class="qb-disconnected__bg-shape qb-disconnected__bg-shape--bottom"></div>

  <div class="qb-disconnected__card">
    <h1 class="qb-disconnected__title">QuickBooks Disconnected</h1>

    <h2 class="qb-disconnected__subtitle">
      Let's get your QuickBooks integration back online.
    </h2>

    <p class="qb-disconnected__text">
      There are times when security tokens expire or passwords change, causing an integration
      to temporarily pause.
    </p>

    <p class="qb-disconnected__text">
      Follow these quick steps to restart your real-time data sync between
      <strong>FieldEx</strong> and <strong>QuickBooks</strong>:
    </p>

    <ol class="qb-disconnected__steps">
      <li class="qb-disconnected__step">
        1. Log in to your <strong>FieldEx dashboard</strong>.
      </li>
      <li class="qb-disconnected__step">
        2. Navigate to <strong>Setup &gt; Integration &gt; Configuration</strong>.
      </li>
      <li class="qb-disconnected__step">
        3. Locate the <strong>QuickBooks</strong> integration and click <strong>Connect</strong>.
      </li>
    </ol>

    <p class="qb-disconnected__help">
      <span class="qb-disconnected__help-label">Need a hand?</span>
      If you run into any trouble getting re-authorized, our technical support
      team is standing by to help at
      <span class="qb-disconnected__link" href="mailto:support@fieldex.com">support&#64;fieldex.com</span>.
    </p>
  </div>
</div>